/**
 **@Description:
 **@author: leo
 */

import {stringify} from 'qs'
import request from 'crm/utils/request'
import api from 'crm/common/api/users'
import {format} from 'utils/index'
// import {format} from 'utils'

export async function query(params) {
    return request(`${api.list.url}?${stringify(params)}`)
}

export async function usersIndependent(params) {
    return request(`${api.usersIndependent.url}?${stringify(params)}`)
}

export async function usersIndependentDetails(params) {
    return request(format(api.usersIndependentDetails.url, {id: params.id}))
}

export async function changeCreator(params = {}) {
    return request(api.changeCreator.url, {
        method: api.changeCreator.type,
        body: params.body,
    })
}

export async function setRole(params = {}) {
    return request(api.setRole.url, {
        method: api.setRole.type,
        body: params.body,
    })
}

export async function setDepartment(params = {}) {
    return request(api.setDepartment.url, {
        method: api.setDepartment.type,
        body: params.body,
    })
}

// 团队管理-更新团队数据
export async function updateTeamData() {
    return request(api.updateTeamData.url, {
        method: api.updateTeamData.type,
    })
}
export async function updateTeamDataState(payload) {
    return request(format(api.updateTeamDataState.url, {task_id: payload.task_id}), {
        method: api.updateTeamDataState.type,
    })
}

// 导出系统操作日志
export async function exportSensitiveEditExcel(params) {
    return request(`${api.exportSensitiveEditExcel.url}?${stringify(params)}`, null, {
        returnResponse: true,
    })
}
